var coll = document.getElementsByClassName("faq");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("faq-active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

var coll = document.getElementsByClassName("collapsible-sfp");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

var checkselect = document.getElementById("option-go2").addEventListener("change", go2);
function go2() {
var selection = document.getElementById("option-go2").value;
if (selection == "Cherry") { document.getElementById("sfp").src = "https://cdn.shopify.com/s/files/1/0706/7808/5951/files/sfp_10021.png?v=1753879714"; }
if (selection == "Orange") { document.getElementById("sfp").src = "https://cdn.shopify.com/s/files/1/0706/7808/5951/files/sfp_10022.png?v=1753879714"; }
if (selection == "Watermelon") { document.getElementById("sfp").src = "https://cdn.shopify.com/s/files/1/0706/7808/5951/files/sfp_10024.png?v=1753879714"; }
}